import styled from "styled-components";
import {Button} from "antd";
import React from "react";

export const StoreButton = styled(props => <Button className={props.className} {...props} />)`
  &.ant-btn:hover, &.ant-btn:focus {
    color: #1fb6c6;
    border-color: #1fb6c6;
  }

  &.ant-btn:active {
    color: #128ea1;
    border-color: #128ea1;
  }

  &.ant-btn-primary {
    color: white;
    background: #1fb6c6;
    border-color: #1fb6c6;
  }

  &.ant-btn-primary:hover, &.ant-btn-primary:focus, &.ant-btn-primary:active {
    color: #c8faf8;
    background: #1fb6c6;
    border-color: #1fb6c6;
  }
`;
